export default {
  getIsLoading: state => {
    return state.isLoading;
  },
  getIsOn: state => {
    return state.isOn;
  },
  getIsFocus: state => {
    return state.isFocus;
  },
  getModalAlertComponents: state => {
    return state.modalAlertComponents;
  },
  getProductBuyMove: state => {
    return state.productBuyMove;
  },
  getModalComponent: state => index => {
    return state.modalComponents[index];
  },
  initMovePath: state => state.initMovePath,
  getModalComponents: state => {
    return state.modalComponents;
  },
  getRouteLayout: state => {
    return state.routeLayout;
  },
  getKeywords(state) {
    state.keywords = JSON.parse(localStorage.getItem('keywords')) || [];
    return state.keywords;
  },
  getScroll: state => state.scroll,
  getKeepAlive: state => state.keepAlive,
  getLoginMovePath: state => {
    if (state.loginMovePath) return state.loginMovePath;
    try { return sessionStorage.getItem('jump.loginMovePath') || ''; } catch (_) { return ''; }
  },
  getIsHeader: state => state.routeLayout.isHeader,
  getBottomSheet: state => state.bottomSheet,
  getIsFloating: state => state.isFloating,
  getOrgNav: state => state.orgNav,
  getParkingNav: state => state.parkingNav,
  getMemberBrowse: state => state.memberBrowse,
  getIsHamburger: state => state.isHamburger,
  getIsWellFloating: state => state.isWellFloating,
  getIsAnnouncement: state => state.routeLayout.isAnnouncement,
  getIsBackFromSearch: state => state.isBackFromSearch,
  getIsTodayExpireDate: state => state.isTodayExpireDate,
  getIsIntroEnter: state => state.isIntroEnter,
  getFormDirty: state => state.formDirty,
  // 260609 리뉴얼: 메인 소비자/사업자 모드
  getHomeMode: state => state.homeMode

};
